import { render, staticRenderFns } from "./BottomAd.vue?vue&type=template&id=4b8bc178&scoped=true"
import script from "./BottomAd.vue?vue&type=script&lang=js"
export * from "./BottomAd.vue?vue&type=script&lang=js"
import style0 from "./BottomAd.vue?vue&type=style&index=0&id=4b8bc178&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b8bc178",
  null
  
)

export default component.exports